import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Kordsa',
  logo: { name: 'Kordsa', src: '/logo/kordsacard.png' },
  portrait: { src: '/photo/portrait-fatih-akar.png', alt: 'Fatih Akar' },
  quote: [
    'Digitopia’s DMI assessments have helped us create clear, actionable digital roadmaps '
    + 'while staying on track.',
    'Their insights have been invaluable, guiding us to focus on critical areas like AI long '
    + 'before it became a major topic. As part of Sabancı Holding, it’s a significant '
    + 'advantage that other group companies also use Digitopia’s assessments, enabling a '
    + 'comprehensive view of digital maturity across the group.',
    'Digitopia is not just a partner. They play an essential role in shaping and driving our '
    + 'digital strategy.',
  ],
  attribution: 'Fatih Akar, Director of Global Information Technologies',
  story: 'kordsa',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 2
